<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'FORMS_TEMPLATES_MODULE.FORM.FORMS_LIST' | translate"
    [viewLoading$]="dataSource?.loading$"
    [class]="'card-head-lg'"
  >
    <ng-container ktPortletTools>
      <div>
        <ng-template ngxPermissionsOnly="canImportGlobalForm">
          <button mat-raised-button class="btn btn-light-primary" (click)="addForm($event, true)">
            <span
              inlineSVG="assets/media/svg/icons/Files/DownloadedFile.svg"
              class="svg-icon svg-icon-md"
            ></span>
            <span>{{ 'FORMS_TEMPLATES_MODULE.FORM.IMPORT_GLOBAL_FORM' | translate }}</span>
          </button>
        </ng-template>
        <ng-template ngxPermissionsOnly="canAddForm">
          <button mat-raised-button class="btn btn-primary ml-2" (click)="addForm($event)">
            <span
              inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"
              class="svg-icon svg-icon-md"
            ></span>
            <span>{{ 'FORMS_TEMPLATES_MODULE.FORM.ADD_FORM' | translate }}</span>
          </button>
        </ng-template>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <button
          style="width: 175px !important"
          class="btn btn-sm btn-light-{{ getStatusClass(searchIsActiveSelect?.value) }} mr-4"
          (click)="toggleIsActive($event)"
        >
          {{ getStatusLabel(searchIsActiveSelect?.value) }} Forms
        </button>
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FORMS_TEMPLATES_MODULE.FORM.ID' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let form">{{ form.id }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchId">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'FORMS_TEMPLATES_MODULE.FORM.ID' | translate }}</mat-label>
              <input
                matInput
                #searchIdInput
                [placeholder]="'FORMS_TEMPLATES_MODULE.FORM.ID' | translate"
              />
              <button
                *ngIf="searchIdInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchIdInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FORMS_TEMPLATES_MODULE.FORM.NAME' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let form">
            <span
              [matTooltip]="canViewForm() ? 'View Form' : null"
              [class.clickable]="canViewForm()"
              (dblclick)="viewForm($event, form)"
              >{{ form.name }}</span
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchName">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'FORMS_TEMPLATES_MODULE.FORM.NAME' | translate }}</mat-label>
              <input
                matInput
                #searchNameInput
                [placeholder]="'FORMS_TEMPLATES_MODULE.FORM.NAME' | translate"
              />
              <button
                *ngIf="searchNameInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchNameInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="teams">
          <mat-header-cell *matHeaderCellDef>{{
            'FORMS_TEMPLATES_MODULE.FORM.TEAMS_CATEGORIES' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let form">
            <ng-container *ngFor="let team of form.teams || []; let idx = index">
              {{ (team ? team.name : '-') + (idx !== form.teams?.length - 1 ? ', ' : '') }}
            </ng-container>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchTeam">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              #searchTeamAutocomplete
              [label]="'FORMS_TEMPLATES_MODULE.FORM.TEAM_CATEGORY' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [control]="searchTeamAutocomplete"
              [loadItemsFunction]="getTeamAutocomplete"
              [optionFormatter]="formatTeamOption"
              [valueFormatter]="formatTeamOption"
              [required]="false"
              [readOnly]="false"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="system">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FORMS_TEMPLATES_MODULE.FORM.SYSTEM' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let form">{{
            stringUtils.formatEnumString(form.system)
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchSystem">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'FORMS_TEMPLATES_MODULE.FORM.SYSTEM' | translate }}</mat-label>
              <mat-select #searchSystemSelect>
                <mat-option value="">All</mat-option>
                <mat-option *ngFor="let system of formSystems" [value]="system">{{
                  stringUtils.formatEnumString(system)
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="version">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FORMS_TEMPLATES_MODULE.FORM.VERSION' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let form">{{ form.version }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchVersion">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'FORMS_TEMPLATES_MODULE.FORM.VERSION' | translate }}</mat-label>
              <input
                matInput
                #searchVersionInput
                [placeholder]="'FORMS_TEMPLATES_MODULE.FORM.VERSION' | translate"
              />
              <button
                *ngIf="searchVersionInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchVersionInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="isActive">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FORMS_TEMPLATES_MODULE.FORM.STATUS' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let form">
            <span
              style="width: 61px"
              class="label label-lg label-light-{{
                getStatusClass(form.is_active?.toString())
              }} label-inline text-center"
            >
              {{ getStatusLabel(form.is_active?.toString()) }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchIsActive">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'FORMS_TEMPLATES_MODULE.FORM.STATUS' | translate }}</mat-label>
              <mat-select
                #searchIsActiveSelect
                [placeholder]="'FORMS_TEMPLATES_MODULE.FORM.STATUS' | translate"
                (selectionChange)="handleIsActiveChange()"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="true">Active</mat-option>
                <mat-option value="false">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let form">
            <ng-template ngxPermissionsOnly="canViewForm">
              <button
                matTooltip="{{ 'TABLE.VIEW' | translate }} Form"
                class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                (click)="viewForm($event, form)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/visible.svg"
                  class="svg-icon svg-icon-md svg-icon-success"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canEditForm">
              <button
                matTooltip="{{ 'TABLE.UPDATE' | translate }} Form"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="updateForm($event, form)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canActivateForm">
              <button
                matTooltip="{{ 'TABLE.ACTIVATE_DEACTIVATE' | translate }} Form"
                class="btn btn-icon btn-light btn-hover-warning btn-sm m-1"
                (click)="toggleFormStatus($event, form)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/update_icon2.svg"
                  class="svg-icon svg-icon-md svg-icon-warning"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="accessToSynonyms">
              <button
                [matTooltip]="'FORMS_TEMPLATES_MODULE.FORM.LINK_TITLE' | translate"
                class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
                (click)="linkFormFieldsToSynonyms($event, form)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/link.svg"
                  class="svg-icon svg-icon-md svg-icon-danger"
                ></span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedCols" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarCols"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedCols"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
